import { z } from "zod";
export const UserSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    name: z.string().nullable(),
    picture_url: z.string().url().nullable(),
    created_at: z.string().datetime(),
    last_login_at: z.string().datetime().nullable(),
});
export const ApiTokenSchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1).max(80),
    created_at: z.string().datetime(),
    last_used_at: z.string().datetime().nullable(),
});
export const CreateApiTokenRequestSchema = z.object({
    name: z.string().min(1).max(80),
});
export const CreateApiTokenResponseSchema = ApiTokenSchema.extend({
    token: z.string().min(20),
});
//# sourceMappingURL=auth.js.map